import { render } from "./IndexNavbar.vue?vue&type=template&id=ce0e7354"
import script from "./IndexNavbar.vue?vue&type=script&lang=js"
export * from "./IndexNavbar.vue?vue&type=script&lang=js"

import "./IndexNavbar.vue?vue&type=style&index=0&id=ce0e7354&lang=css"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__